var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruckThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "currentColor",
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.333 11.667a1.167 1.167 0 1 0 0 2.333 1.167 1.167 0 0 0 0-2.333m-2.166 1.167a2.167 2.167 0 1 1 4.333 0 2.167 2.167 0 0 1-4.333 0m-6.5-1.167a1.167 1.167 0 1 0 0 2.333 1.167 1.167 0 0 0 0-2.333M1.5 12.834a2.167 2.167 0 1 1 4.333 0 2.167 2.167 0 0 1-4.333 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.167 5.833a.5.5 0 0 1 .5-.5h2.666a.5.5 0 0 1 .354.146l2 2a.5.5 0 0 1 .146.354v3.333a.5.5 0 0 1-.5.5h-4.666a.5.5 0 0 1-.5-.5zm1 .5v4.333h3.666V8.04l-1.707-1.707z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M.167 2.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v8.667a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5zm1 .5v7.667h9V3z"
})));
export default SvgTruckThin;